import { render, staticRenderFns } from "./Discover.html?vue&type=template&id=452531a3&scoped=true&"
import script from "./Discover.js?vue&type=script&lang=js&"
export * from "./Discover.js?vue&type=script&lang=js&"
import style0 from "./Discover.scss?vue&type=style&index=0&id=452531a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452531a3",
  null
  
)

export default component.exports